<template>
  <b-overlay :show="isLoading">
    <b-row>
      <b-col cols="12">
        <b-card>
          <div class="d-flex align-items-center justify-content-between mb-3">
            <h1>صفحه سوالات متداول</h1>
            <b-button variant="primary" v-b-modal.modal-create-faq>
              ایجاد سوال متداول جدید
            </b-button>
          </div>
          <div class="my-2">
            <b-table
              ref="refUserListTable"
              class="position-relative"
              :items="popularQuestionsList"
              responsive
              :fields="myTableColumns"
              primary-key="id"
              show-empty
              bordered
              striped
              empty-text="موردی موجود نیست!"
            >
              <template #cell(answer)="data">
                <div class="text-truncate d-flex align-items-center">
                  <p style="max-width: 10rem">
                    {{ data.item.answer }}
                  </p>
                </div>
              </template>
              <template #cell(createDate)="data">
                {{ new Date(data.item.createDate).toLocaleDateString("fa-IR") }}
              </template>
              <template #cell(type)="data">
                {{ questionTypes[data.item.type] }}
              </template>
              <template #cell(edit)="data">
                <b-button
                  variant="transparent"
                  @click="setTempQuestionEdit(data.item)"
                >
                  <feather-icon
                    class="text-primary"
                    icon="EditIcon"
                    size="20"
                  />
                </b-button>
              </template>
              <template #cell(Delete)="data">
                <b-button
                  variant="transparent"
                  @click="setTempQuestionDelete(data.item)"
                >
                  <feather-icon
                    class="text-danger"
                    icon="Trash2Icon"
                    size="20"
                  />
                </b-button>
              </template>
            </b-table>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end py-2"
            >
              <b-pagination
                v-model="pageNumber"
                :total-rows="totalCount"
                :per-page="count"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    style="transform: rotate(180deg)"
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <!-- Faq Create Modal Start -->
    <b-modal
      title="ایجاد سوال متداول جدید"
      id="modal-create-faq"
      centered
      ok-title="ایجاد"
      cancel-title="بستن"
      @ok="createNewFaq"
    >
      <b-container fluid>
        <b-form-row>
          <b-col cols="12">
            <b-form-group label="متن سوال" label-for="question-text">
              <b-form-input
                size="sm"
                id="question-text"
                v-model="faqDetails.text"
                placeholder="چگونه می‌توان در فرمن عضو شد؟"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label="متن جواب" label-for="answer-text">
              <b-form-textarea
                size="sm"
                id="answer-text"
                placeholder="برای عضویت در فرمن بر روی گزینه «ثبت نام» کلیک کنید."
                v-model="faqDetails.answer"
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group label-for="faqType" label="دسته بندی سوال">
              <b-form-select
                id="faqType"
                v-model="faqDetails.type"
                :options="faqTypes"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-form-row>
      </b-container>
    </b-modal>
    <!-- Faq Create Modal End -->
    <!-- Faq Edit Modal Start -->
    <b-modal
      title="ویرایش سوال متداول"
      id="modal-update-faq"
      centered
      ok-title="ویرایش"
      cancel-title="بستن"
      @ok="updateFaq"
    >
      <template v-if="tempFaq">
        <b-container fluid>
          <b-form-row>
            <b-col cols="12">
              <b-form-group label="متن سوال" label-for="question-text">
                <b-form-input
                  size="sm"
                  id="question-text"
                  v-model="tempFaq.text"
                  placeholder="چگونه می‌توان در فرمن عضو شد؟"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label="متن جواب" label-for="answer-text">
                <b-form-textarea
                  size="sm"
                  id="answer-text"
                  placeholder="برای عضویت در فرمن بر روی گزینه «ثبت نام» کلیک کنید."
                  v-model="tempFaq.answer"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
            <b-col cols="12">
              <b-form-group label-for="faqType" label="دسته بندی سوال">
                <b-form-select
                  id="faqType"
                  v-model="tempFaq.type"
                  :options="faqTypes"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-form-row>
        </b-container>
      </template>
    </b-modal>
    <!-- Faq Edit Modal End -->
    <!-- Faq Delete Modal Start -->
    <b-modal
      title="حذف سوال متداول"
      id="modal-delete-faq"
      centered
      ok-title="بله"
      cancel-title="خیر"
      @ok="deleteFaq"
    >
      <p>آیا از حذف سوال اطمینان دارید؟</p>
    </b-modal>
    <!-- Faq Delete Modal End -->
  </b-overlay>
</template>
<script>
export default {
  data() {
    return {
      isLoading: false,
      pageNumber: 1,
      count: 10,
      totalCount: null,
      pageDetails: null,
      popularQuestionsList: null,
      tempFaq: null,
      faqDetails: {
        isDeleted: false,
        popularQuestionId: 0,
        text: null,
        answer: null,
        dynamicPageId: null,
        priority: 1,
        type: null,
        createDate: new Date(Date.now()),
      },
      questionTypes: {
        1: "ورود و عضویت",
        2: "کلاس ها و مدرسین",
        3: "فایل های همراه",
      },
      faqTypes: [
        //  Popular = 1,
        // AboutMasters = 2,
        // AboutCourses = 3,
        // Payment = 4
        {
          value: null,
          text: "یک گزینه را انتخاب کنید",
        },
        {
          value: 1,
          text: "ورود و عضویت",
        },
        {
          value: 2,
          text: "کلاس ها و مدرسین",
        },
        {
          value: 3,
          text: "فایل های همراه",
        },
      ],
      myTableColumns: [
        {
          key: "popularQuestionId",
          label: "شناسه سوال",
        },
        {
          key: "text",
          label: "سوال",
        },
        {
          key: "answer",
          label: "جواب",
        },
        {
          key: "createDate",
          label: "تاریخ ثبت",
        },
        {
          key: "type",
          label: "دسته بندی",
        },
        {
          key: "Edit",
          label: "ویرایش",
        },
        {
          key: "Delete",
          label: "حذف",
        },
      ],
    };
  },
  mounted() {
    // this.getPageBySeoUrl();
    this.getPageById();
    this.getAllPopularQuestion();
  },
  methods: {
    async deleteFaq() {
      try {
        this.isLoading = true;
        let _this = this;
        let deletePopularQuestion = new DeletePopularQuestion(_this);
        deletePopularQuestion.setRequestParam({
          id: _this.tempFaq.popularQuestionId,
        });
        await deletePopularQuestion.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "سوال با موفقیت حذف شد",
                icon: "CheckIcon",
                variant: "success",
              },
            });
            _this.$bvModal.hide("modal-delete-faq");
            _this.tempFaq = null;
            _this.getAllPopularQuestion();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.tempFaq = null;
        this.isLoading = false;
      }
    },
    async updateFaq() {
      try {
        this.isLoading = true;
        let _this = this;
        let updatePopularQuestion = new UpdatePopularQuestion(_this);
        updatePopularQuestion.setRequestParamDataObj(_this.tempFaq);
        await updatePopularQuestion.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "سوال با موفقیت ویرایش شد",
                icon: "CheckIcon",
                variant: "success",
              },
            });
            _this.$bvModal.hide("modal-update-faq");
            _this.tempFaq = null;
            _this.getAllPopularQuestion();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    setTempQuestionEdit(faq) {
      this.tempFaq = JSON.parse(JSON.stringify(faq));
      this.$bvModal.show("modal-update-faq");
    },
    setTempQuestionDelete(faq) {
      this.tempFaq = JSON.parse(JSON.stringify(faq));
      this.$bvModal.show("modal-delete-faq");
    },
    // async getPageBySeoUrl() {
    //   try {
    //     this.isLoading = true;
    //     let _this = this;
    //     let getPageBySeoUrl = new GetPageBySeoUrl(_this);
    //     getPageBySeoUrl.setRequestParam({
    //       seoUrl: "faq",
    //     });
    //     await getPageBySeoUrl.fetch((response) => {
    //       if (response.isSuccess) {
    //         console.log(response.data);
    //       }
    //     });
    //   } catch (error) {
    //     console.error(error);
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },
    async createNewFaq() {
      try {
        if (this.popularQuestionsList?.length > 0) {
          this.faqDetails.priority =
            this.popularQuestionsList[this.popularQuestionsList.length - 1]
              .priority + 1;
        }
        this.faqDetails.dynamicPageId = this.$route.params.id;
        this.isLoading = true;
        let _this = this;
        let createPopularQuestion = new CreatePopularQuestion(_this);
        createPopularQuestion.setRequestParamDataObj([_this.faqDetails]);
        await createPopularQuestion.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "سوال با موفقیت ایجاد شد",
                icon: "CheckIcon",
                variant: "success",
              },
            });
            _this.faqDetails = {
              isDeleted: false,
              popularQuestionId: 0,
              text: null,
              answer: null,
              dynamicPageId: null,
              priority: 1,
              type: null,
              createDate: new Date(Date.now()),
            };
            _this.getAllPopularQuestion();
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getAllPopularQuestion() {
      try {
        this.isLoading = true;
        let _this = this;
        let getAllPopularQuestions = new GetAllPopularQuestions(_this);
        getAllPopularQuestions.setRequestParam({
          count: _this.count,
          pageNumber: _this.pageNumber,
          dynamicPageId: _this.$route.params.id,
        });
        await getAllPopularQuestions.fetch((response) => {
          if (response.isSuccess) {
            _this.totalCount = response.data.popularQuestionsCount;
            _this.popularQuestionsList = response.data.popularQuestions;
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async getPageById() {
      try {
        this.isLoading = true;
        let _this = this;
        let getPageById = new GetPageById(_this);
        getPageById.setRequestParam({
          id: _this.$route.params.id,
        });
        await getPageById.fetch((response) => {
          if (response.isSuccess) {
            _this.pageDetails = response.data;
            console.log(_this.pageDetails);
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  components: {
    BFormRow,
    BContainer,
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BButton,
    BTable,
    BModal,
    BPagination,
    BOverlay,
    vSelect,
  },
};
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";
import { GetPageBySeoUrl, GetPageById } from "@/libs/Api/DynamicPages";
import {
  CreatePopularQuestion,
  GetAllPopularQuestions,
  UpdatePopularQuestion,
  DeletePopularQuestion,
} from "@/libs/Api/PopularQuestions";
import {
  BContainer,
  BCard,
  BRow,
  BFormRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BButton,
  BTable,
  BModal,
  BPagination,
  BOverlay,
} from "bootstrap-vue";
</script>
